<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">lock_person</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a (click)="navigateTo()">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.parametres.api.rest.liste.type'"></strong>
                <span translate>{{ 'admin.parametres.api.rest.liste.' + (data.comptePersonnel ? 'comptePerso' : 'compteService') }}</span>
            </li>
            <li>
                <strong [translate]="'admin.parametres.api.rest.liste.identifiant'"></strong>
                <span>{{ data.identifiant }}</span>
            </li>
            <li>
                <strong [translate]="'admin.parametres.api.rest.liste.email'"></strong>
                <span>{{ data.email }}</span>
            </li>
            <li *ngIf="data.derniereConnexion">
                <strong [translate]="'admin.parametres.api.rest.liste.derniereConnexion'"></strong>
                <span>{{ data.derniereConnexion | date: 'shortDate' }} {{ data.derniereConnexion | date: 'shortTime' }}</span>
            </li>
            <li *ngIf="data.dateCloture">
                <strong [translate]="'admin.parametres.api.rest.liste.dateCloture'"></strong>
                <span translate>{{ data.dateCloture | date: 'shortDate' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.parametres.api.rest.liste.actif'"></strong>
                <span translate>{{ 'admin.parametres.api.rest.liste.' + (data.verrouille ? 'verrouille' : (data.actif ? 'oui' : 'non')) }}</span>
            </li>
        </ul>
    </div>
    <div *ngIf="!data.derniereConnexion" class="lvi-actions">
        <button mat-icon-button (click)="deleteCompte()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>